/**
 * Noms des canaux par lesquels la locale circule entre client, middleware et
 * serveur.
 *
 * Module **sans aucune dépendance**, et c'est sa raison d'être : ces constantes
 * sont lues par le middleware (runtime Node, hors React) et par du code client.
 * Les héberger dans `request.ts` — qui importe `next/headers` — casse le build
 * (« You're importing a component that needs next/headers ») et tirerait une API
 * serveur dans le bundle client.
 */

/** Cookie de persistance du choix de langue. Nom attendu par next-intl. */
export const LOCALE_COOKIE = 'NEXT_LOCALE';

/**
 * Header par lequel un appelant transmet explicitement sa locale aux routes
 * `/api/**`. Ces routes vivent hors du segment `[locale]`, donc `requestLocale`
 * y est toujours `undefined` : sans ce header elles retomberaient sur le cookie,
 * qui peut diverger de l'URL de la page appelante (deux onglets ouverts dans
 * deux langues différentes).
 */
export const LOCALE_HEADER = 'x-locale';
